module.exports = __webpack_public_path__ + "img/login_page_bac0.06e15296.jpg";